import { es as reactEs } from '@ews/react-translations';

const es = {
    ...reactEs
};
export default es;
